module.exports = "\r\n\r\n\r\n.panel {\r\n  border: 1px solid #d1d6e6;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notification-components/action-based-notifications/create-action-notification/create-action-notification.component.css
// module id = ./src/app/notification-components/action-based-notifications/create-action-notification/create-action-notification.component.css
// module chunks = main